// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface IPerPersonSpendLimitAmountPropertyDto
 */
export interface IPerPersonSpendLimitAmountPropertyDto {
    /**
     * 
     * @type {number}
     * @memberof IPerPersonSpendLimitAmountPropertyDto
     */
    per_person_spend_limit_amount?: number;
    /**
     * 
     * @type {string}
     * @memberof IPerPersonSpendLimitAmountPropertyDto
     */
    per_person_spend_limit_amount_state?: IPerPersonSpendLimitAmountPropertyDtoPerPersonSpendLimitAmountStateEnum;
}

/**
* @export
* @enum {string}
*/
export enum IPerPersonSpendLimitAmountPropertyDtoPerPersonSpendLimitAmountStateEnum {
    MODIFIABLE = 'MODIFIABLE',
    LOCKED = 'LOCKED',
    HIDDEN = 'HIDDEN',
    REQUIRED_AT_PLAN = 'REQUIRED_AT_PLAN',
    REQUIRED_AT_ALL_LEVELS = 'REQUIRED_AT_ALL_LEVELS'
}


/**
 * Check if a given object implements the IPerPersonSpendLimitAmountPropertyDto interface.
 */
export function instanceOfIPerPersonSpendLimitAmountPropertyDto(value: object): value is IPerPersonSpendLimitAmountPropertyDto {
    return true;
}

export function IPerPersonSpendLimitAmountPropertyDtoFromJSON(json: any): IPerPersonSpendLimitAmountPropertyDto {
    return IPerPersonSpendLimitAmountPropertyDtoFromJSONTyped(json, false);
}

export function IPerPersonSpendLimitAmountPropertyDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IPerPersonSpendLimitAmountPropertyDto {
    if (json == null) {
        return json;
    }
    return {
        
        'per_person_spend_limit_amount': json['per_person_spend_limit_amount'] == null ? undefined : json['per_person_spend_limit_amount'],
        'per_person_spend_limit_amount_state': json['per_person_spend_limit_amount_state'] == null ? undefined : json['per_person_spend_limit_amount_state'],
    };
}

export function IPerPersonSpendLimitAmountPropertyDtoToJSON(json: any): IPerPersonSpendLimitAmountPropertyDto {
    return IPerPersonSpendLimitAmountPropertyDtoToJSONTyped(json, false);
}

export function IPerPersonSpendLimitAmountPropertyDtoToJSONTyped(value?: IPerPersonSpendLimitAmountPropertyDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'per_person_spend_limit_amount': value['per_person_spend_limit_amount'],
        'per_person_spend_limit_amount_state': value['per_person_spend_limit_amount_state'],
    };
}

